import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-enroll',
  templateUrl: './enroll.component.html',
  styleUrls: ['./enroll.component.scss']
})
export class EnrollComponent {

  constructor(private router: Router) {}

  contactSupport() {
    this.router.navigateByUrl('/support');
  }
}
